module.exports = __webpack_public_path__ + "assets/img/avatar.ae397cb1.png";